<template>
  <div class="pa-container">
    <div class="pa-topbar"></div>
    <div>
      <div class="pa-header row">
        <div class="col-6 lable">{{ "NAME" }}</div>
        <div class="col-6 active">{{ "Active" }}</div>
      </div>
      <div
        class="pa-data row"
        v-for="(practice, index) in practices.slice(0, 4)"
        :key="index"
      >
        <div class="col-6 lable">
          {{ practice.name }}
        </div>
        <div class="active col-6">
          <img
            v-if="practice.active"
            class="align-self-center mx-2 status-icon"
            src="@/assets/images/tick_green.svg"
            alt=""
          />
          <img
            v-else
            class="align-self-center mx-2 status-icon"
            src="@/assets/images/cross_red.svg"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      practices: [
        { name: "Mickey Mouse", active: true },
        { name: "Donald Duck", active: true },
        { name: "Mickey Mouse", active: false },
        { name: "Donald Duck", active: false },
      ],
    };
  },
};
</script>
<style>
.pa-container {
  background: #fff;
  min-height: 300px;
}
.pa-topbar {
  height: 4px;
  background: #c0007c;
}
.pa-header {
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #000;
  display: flex;
  justify-content: space-around;
  margin: 15px 10px;
  padding: 0px 5px;
}
.pa-data {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #000;
  padding: 13px 0px;
  border-top: 1px solid #d2d6de;
  margin: 0px 14px;
}
.pa-data .lable,
.pa-header .lable {
  text-align: left;
  padding: 0;
}
.pa-data .active,
.pa-header .active {
  text-align: right;
  padding: 0;
}
.pa-data:last-child {
  border-bottom: 1px solid #d2d6de;
}
</style>
